import * as React from "react"

export const MicrosoftLogo = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0H11.4047V11.4047H0V0Z" fill="#F25022"></path>
      <path d="M12.5953 0H24V11.4047H12.5953V0Z" fill="#7FBA00"></path>
      <path d="M0 12.5955H11.4046V24.0001H0V12.5955Z" fill="#00A4EF"></path>
      <path
        d="M12.5953 12.5955H24V24.0001H12.5953V12.5955Z"
        fill="#FFB900"
      ></path>
    </svg>
  )
}
